module.exports = __webpack_public_path__ + "assets/img/ja-3036505b.png";